import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import NPSSurveyForm from '../../components/NPS/NPSSurveyForm';
import Spinner from '../../components/Spinner';
import useFetch from '../../helpers/useFetch';

const NPSSurveyDetailsPage = () => {
  const fetch = useFetch();
  const navigate = useNavigate();
  const { accountId, domainId, npsId } = useParams();

  const [npsSurvey, setNpsSurvey] = useState();
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState();
  const [saveError, setSaveError] = useState();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/nps-surveys/${npsId}`)
      .then(({ npsSurvey }) => setNpsSurvey(npsSurvey))
      .catch(setLoadError);
  }, [accountId, domainId, npsId, fetch]);

  const update = (data) => {
    setLoading(true);
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/nps-surveys/${npsId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    })
      .then(() => navigate(`/accounts/${accountId}/domains/${domainId}/nps`))
      .catch(setSaveError)
      .finally(() => setLoading(false));
  };

  const del = () => {
    setLoading(true);
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/nps-surveys/${npsId}`, {
      method: 'DELETE',
    })
      .then(() => navigate(`/accounts/${accountId}/domains/${domainId}/nps`))
      .catch(setSaveError)
      .finally(() => setLoading(false));
  };

  if (loadError) return <ErrorMessage message={loadError.message} />;
  if (npsSurvey === undefined) return <Spinner />;
  if (!npsSurvey) return <ErrorMessage message="NPS survey not found." />;

  return (
    <>
      <Metadata title={`NPS Surveys | ${npsSurvey.name} | Edit`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/nps`}>NPS Surveys</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/nps/${npsId}/analytics`}>
          {npsSurvey.name}
        </Anchor>
        <Text>Edit</Text>
      </Breadcrumbs>

      <Grid>
        <Grid.Col span={12}>
          <NPSSurveyForm
            npsSurvey={npsSurvey}
            loading={loading}
            saveNpsSurvey={update}
            deleteNpsSurvey={del}
            cancel={() => navigate(`/accounts/${accountId}/domains/${domainId}/nps`)}
          />
        </Grid.Col>
      </Grid>

      {saveError && (
        <div style={{ textAlign: 'right', marginTop: 8 }}>
          <ErrorMessage message={saveError.message} />
        </div>
      )}
    </>
  );
};

export default NPSSurveyDetailsPage;
